import { render, staticRenderFns } from "./ParcelTax.vue?vue&type=template&id=4981df7d&"
import script from "./ParcelTax.vue?vue&type=script&lang=js&"
export * from "./ParcelTax.vue?vue&type=script&lang=js&"
import style0 from "./ParcelTax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports